var exports = {
  "y": "avatarStack__EMhvSW",
  "m": "avatar__ppR01l",
};

module.exports = exports;
